import { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getImportClientDetail } from "store/clients"

/**
 * Custom hook to manage import detail data fetching and state
 * Follows Single Responsibility Principle by isolating data fetching logic
 *
 * @param {string|number} importId - The import record ID to fetch details for
 * @returns {Object} Import detail data and metadata
 */
const useImportDetail = (importId) => {
  const dispatch = useDispatch()
  const { importClientDetailData } = useSelector((state) => state.clients)
  const resultInfo = importClientDetailData?.data?.result
  // Fetch import details when ID changes
  useEffect(() => {
    if (importId) {
      dispatch(getImportClientDetail(importId))
    }
  }, [dispatch, importId])

  // Memoized computed values
  const computedData = useMemo(
    () => ({
      filename: importClientDetailData?.data?.filename || "",
      importId: importClientDetailData?.data?.id,
      successCount: resultInfo?.success_count || 0,
      failedCount: resultInfo?.failed_count || 0,
      duplicateCount: resultInfo?.duplicate_count || 0,
      failedRecords: resultInfo?.failed_records || {},
      duplicateRecords: resultInfo?.duplicate_records || {},
      failedRecordsUrl: importClientDetailData?.data?.failed_records_url || ""
    }),
    [importClientDetailData, resultInfo]
  )

  return {
    ...computedData,
    isLoading: !importClientDetailData,
    rawData: importClientDetailData
  }
}

export default useImportDetail
